import { Box, Typography } from "@mui/material";
import CreateRobotScreen from "../robot/create";
import { COLOR } from "../../../utils/colors";

export default function CreateRobotQuickSetup({
  onSubmit,
  selectedBuildingId,
  onCancel
}: {
  onSubmit?: () => void,
  selectedBuildingId?: string
  onCancel?: () => void
}) {
  return (
    <Box sx={{
      paddingInline: '64px',
      paddingTop: '64px',
      paddingBottom: '24px'
    }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', mb: '24px' }}>
        <Typography
          sx={{
            fontSize: '24px',
            fontWeight: 600,
            color: COLOR.neutral[900]
          }}
        >
          Create Robot
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 400,
            color: COLOR.neutral[900],
            opacity: 0.6,
          }}
        >
          Fill in the details below to create a new robot.
        </Typography>
      </Box>
      <CreateRobotScreen hideTitle onSubmit={onSubmit} selectedBuildingId={selectedBuildingId} onCancel={() => onCancel?.()} />
    </Box>
  )
}